
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanSquare as ObiBuoyCanSquareElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-square.js';
 
 
 

 
 export const ObiBuoyCanSquare = createComponent({
   react: React,
   tagName: 'obi-buoy-can-square',
   elementClass: ObiBuoyCanSquareElement,
   events: {
     
   }
  });
 
 